import { useTranslation } from 'react-i18next'

import { InputWithLabel, PhonePrefixSelector, Text } from '@reveni-io/reveni-ui'

import CountrySelector from './RegionSelector/RegionSelector'
import * as Styles from './styles'

const AddressSection = ({
  regions,
  provinces,
  country,
  province,
  locality,
  postalCode,
  line1,
  line2,
  houseNumber,
  onChangeCountry,
  setProvince,
  setLine1,
  setLine2,
  setHouseNumber,
  setLocality,
  setPostalCode,
  phone,
  setPhone,
  phonePrefix,
  setPhonePrefix,
}) => {
  const { t } = useTranslation()

  const handleLine1Change = e => setLine1(e.target.value)
  const handleHouseNumberChange = e => setHouseNumber(e.target.value)
  const handleLine2Change = e => setLine2(e.target.value)
  const handleLocalityChange = e => setLocality(e.target.value)
  const handlePostalCodeChange = e => setPostalCode(e.target.value)
  const handlePhoneChange = e => setPhone(e.target.value)
  const handlePhonePrefixChange = e => setPhonePrefix(e.target.value)

  return (
    <Styles.Container>
      <Text type="titleS">{t('Dirección')}</Text>
      <Styles.AddressContainer hasProvince={provinces?.length}>
        <InputWithLabel label={t('Calle')} value={line1} onChange={handleLine1Change} fullWidth />
        <InputWithLabel label={t('Número')} value={houseNumber} onChange={handleHouseNumberChange} fullWidth />
        <InputWithLabel
          label={t('Apartamento, local, etc. (opcional)')}
          value={line2}
          onChange={handleLine2Change}
          fullWidth
        />
        <CountrySelector regions={regions} label={t('País')} onChange={onChangeCountry} value={country} />
        <CountrySelector regions={provinces} label={t('Provincia')} onChange={setProvince} value={province} />
        <InputWithLabel label={t('Ciudad')} value={locality} onChange={handleLocalityChange} fullWidth />
        <InputWithLabel label={t('Código postal')} value={postalCode} onChange={handlePostalCodeChange} fullWidth />
        <Styles.PhoneRow>
          <PhonePrefixSelector
            name="phonePrefix"
            label={t('Prefijo')}
            value={phonePrefix}
            onChange={handlePhonePrefixChange}
          />
          <InputWithLabel label={t('Teléfono')} value={phone} onChange={handlePhoneChange} fullWidth />
        </Styles.PhoneRow>
      </Styles.AddressContainer>
    </Styles.Container>
  )
}

export default AddressSection
